// extracted by mini-css-extract-plugin
module.exports = {"button":"_3tDgYQG0Y3_RbV37fwxHDE","primary":"_1XaIXXv4EL7q1lkXJn_zod","secondary":"_1ulLbF8JPsZ2lATMDNHNxO","large":"_3NIwGsXni65wJmoPS45qFN"};